import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ServiceDetails5 from "../components/sections/ServiceDetails5"
import Imgsec1 from "../components/sections/imgsec1"
export default function ServicesDetails() {
	return (
		<>
			<Layout
				headerStyle={1}
				footerStyle={1}
				// breadcrumbTitle="Services details"
			>
				<ServiceDetails5 />
				{/* <Brand1 /> */}
				<Imgsec1 />
			</Layout>
		</>
	)
}
